document.querySelectorAll("[data-guide-accordion]").forEach(function (section) {
  if (section.dataset.guideAccordionReady) return;
  section.dataset.guideAccordionReady = "true";

  var questions = section.querySelectorAll(".guide-accordion__header");

  questions.forEach(function (element) {
    element.addEventListener("click", function () {
      var parent = element.closest(".guide-accordion__item");
      if (!parent) return;

      questions.forEach(function (item) {
        var itemParent = item.closest(".guide-accordion__item");
        if (itemParent && itemParent !== parent) {
          itemParent.classList.remove("guide-accordion__item--active");
          item.setAttribute("aria-expanded", "false");
        }
      });

      var isOpen = parent.classList.toggle("guide-accordion__item--active");
      element.setAttribute("aria-expanded", isOpen ? "true" : "false");
    });
  });
});
